import { cp } from "../config";

/**
 * Origin + router basename: links stay on the current environment — unlike
 * REACT_APP_P6_BASE_WEBSITE links, which always target the phase6 website.
 */
export const getAppBaseUrl = (): string => `${window.location.origin}${cp.cfg.REACT_APP_PREFIX ?? ""}`;

export const getAppDisplayBaseUrl = (): string => `${window.location.host}${cp.cfg.REACT_APP_PREFIX ?? ""}`;
